import { useEffect, useState } from "react";
import moment from "moment";
import ValueTooltip from "./value-tooltip";

type Props = {
  computedAt: string;
};

/** How often "x minutes ago" is re-worked out while the page stays open. */
const TICK_MS = 30 * 1000;

/** Exact build time in UK time, whatever the viewer's own timezone is. */
const ukTime = (value: string) =>
  new Date(value).toLocaleString("en-GB", {
    timeZone: "Europe/London",
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZoneName: "short",
  });

/** "Charts built 5 minutes ago", or the full date once it is over a day old, exact UK time on hover. */
export default function BuiltTime({ computedAt }: Props) {
  const [, setTick] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setTick((tick) => tick + 1), TICK_MS);
    return () => clearInterval(timer);
  }, []);

  const isOverADay = moment().diff(moment(computedAt), "days") >= 1;

  return (
    <ValueTooltip label={`Built ${ukTime(computedAt)}`}>
      <span className="cursor-default">
        Charts built{" "}
        {isOverADay
          ? moment(computedAt).format("D MMM YYYY, HH:mm")
          : moment(computedAt).fromNow()}
      </span>
    </ValueTooltip>
  );
}
